import {
  GetMarketplaceCompanyInstallationsDocument,
  GetMarketplaceCompanyInstallationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetMarketplaceCompanyInstallations = (
  variables: GetMarketplaceCompanyInstallationsQueryVariables,
  hasComponent: boolean
) => {
  const { loading, data, refetch } = useQuery(GetMarketplaceCompanyInstallationsDocument, {
    variables,
    skip: hasComponent,
  })

  return {
    loading,
    data: data?.marketplace.companyInstallationsConnection.nodes || [],
    refetch,
  }
}
